<template>
    <div id="MediaPack">
        <form v-on:submit.prevent>
            <label>Project Name:</label><input type="text" v-model="project_name">
            <label>Project Logo (200x100px):</label><input type="file" id="fileBox">
            <input class="button" @click="PrepareProposal" value="Generate Proposal">
        </form>
        <a v-if="dl_link" target="_blank" :href="dl_link">Download Proposal</a>
    </div>
</template>

<script>
    // Import Helpers
    import {CallApi, fileToB64} from '../Utilities.js'

    // Module Code
    export default {
        data:  function () { 
            return {
                project_name: '',
                project_logo: '',
                dl_link: ''
            }
        },
        methods: {
            PrepareProposal: async function() {
                // Convert File to B64
                const fileInput = document.getElementById('fileBox')
                const fileB64 = (fileInput.files.length != 0) ? await fileToB64(fileInput.files[0]) : null
                fileInput.value = ''

                // Call Api
                const payload = {project_name: this.project_name, project_logo:fileB64}

                this.project_name = ''
                this.project_logo = ''
                this.dl_link = await CallApi('POST', '/mediapack', payload)
            }
        }
    }
</script>